export enum getCategoriesAction {
  GET_CATEGORIES = "GET_CATEGORIES",
  GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS",
  GET_CATEGORIES_FAILURE = "GET_CATEGORIES_FAILURE",
}

export enum cartProductsAction {
  ADD_PRODUCTS_START = "ADD_PRODUCTS_START",
  ADD_PRODUCTS_SUCCESS = "ADD_PRODUCTS_SUCCESS",
  ADD_PRODUCTS_FAILURE = "ADD_PRODUCTS_FAILURE",
  REMOVE_PRODUCT = "REMOVE_PRODUCT",
}

export enum getProductsAction {
  GET_PRODUCTS = "GET_PRODUCTS",
  GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS",
  GET_PRODUCTS_FILTER = "GET_PRODUCTS_FILTER",
  GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE",
}

export enum getModalProductAction {
  GET_MODAL_PRODUCT = "GET_MODAL_PRODUCT",
  GET_MODAL_PRODUCT_SUCCESS = "GET_MODAL_PRODUCT_SUCCESS",
  GET_MODAL_PRODUCT_FAILURE = "GET_MODAL_PRODUCT_FAILURE",
  GET_MODAL_PRODUCT_CLEAR = "GET_MODAL_PRODUCT_CLEAR",
}
